import { ChangeEvent, useState } from "react";

export const useForm = (initialState: any = {}) => {
    const [values, setValues] = useState(initialState);

    const reset = () => {
        setValues(initialState);
    };

    const setNuewValues = (newValues: any) => {
        setValues(newValues);
    }

    const handleInputChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = target;

        setValues({
            ...values,
            [name]: value,
        });
    };

    return [values, handleInputChange, reset, setNuewValues];
};
